import { usePostSubmitActions } from "@circle-react/components/QuickPostV3/Composer/usePostSubmitActions";
import { QUICK_POST_V3_FORM_ID } from "@circle-react/components/QuickPostV3/constants";
import { useSubmitEligibility } from "@circle-react/components/QuickPostV3/hooks/useSubmitEligibility";
import { Button } from "@circleco/compass/components/Button";
import { SplitButton } from "@circleco/compass/components/SplitButton";
import { Tooltip } from "@circleco/compass/components/Tooltip";
import { useRef } from "react";

import { FooterSchedulePicker } from "@/react/components/PostsCompass/FooterSchedulePicker";

interface SubmitButtonProps {
  menuSide?: "top" | "bottom";
}

export const SubmitButton = ({ menuSide = "top" }: SubmitButtonProps = {}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const { errorMessage, isDisabled } = useSubmitEligibility();
  const {
    disabledDays,
    getSubmitLabel,
    isEdit,
    isFooterSchedulePickerOpen,
    menuOptions,
    onScheduleDateSave,
    scheduledAt,
    selectedAction,
    setIsFooterSchedulePickerOpen,
    shouldRenderFooterSchedulePicker,
    shouldShowActionSelector,
  } = usePostSubmitActions();

  const label = shouldShowActionSelector
    ? selectedAction.label
    : getSubmitLabel({ isEdit });
  const submitProps = {
    disabled: isDisabled,
    form: QUICK_POST_V3_FORM_ID,
    type: "submit",
  } as const;

  const button = shouldShowActionSelector ? (
    <SplitButton
      variant="primary"
      size="md"
      align="end"
      side={menuSide}
      menuOptions={menuOptions}
      {...submitProps}
    >
      {label}
    </SplitButton>
  ) : (
    <Button variant="primary" size="md" {...submitProps}>
      {label}
    </Button>
  );

  return (
    <div ref={containerRef}>
      {shouldRenderFooterSchedulePicker && (
        <FooterSchedulePicker
          anchor={containerRef}
          disabledDays={disabledDays}
          onOpenChange={setIsFooterSchedulePickerOpen}
          onSave={onScheduleDateSave}
          open={isFooterSchedulePickerOpen}
          value={scheduledAt}
        />
      )}
      <Tooltip content={errorMessage ?? ""} disabled={!errorMessage}>
        {button}
      </Tooltip>
    </div>
  );
};
